
<script setup>

  import { ref, computed, onBeforeUnmount } from 'vue';

  import layers from '../images/splash-title-*.svg';

  const props = defineProps( { duration: Number } );

  const emit = defineEmits( [ 'next' ] );

  let frame = null;

  let start = null;

  const alpha = ref( 0 );
  
  const delay = computed( () => props.duration / Object.keys( layers ).length );

  const opacity = key => Math.max( 0, Math.min( 1, alpha.value - ( parseInt( key ) - 1 ) ) );

  function step( now ) {

    if ( ! start ) start = now;

    const delta = now - start;

    alpha.value = delta / delay.value;

    if ( delta < props.duration ) frame = requestAnimationFrame( step );

    else emit( 'next' );

  }

  function animate() {

    cancelAnimationFrame( frame );

    start = null;

    step( performance.now() );

  }

  onBeforeUnmount( () => cancelAnimationFrame( frame ) );

  defineExpose( { animate } );

</script>

<template>

  <div class="grid items-center justify-center relative p-6 drop-shadow-[0_0_15px_rgba(0,0,0,1)]"
  
    aria-role="img" aria-label="Life at Lewis Mountain. Shenandoah in the Jim Crow Era.">

    <img v-for="( path, key ) in layers" class="row-start-1 col-start-1 w-[420px]" draggable="false"
    
      :src="path" :style="{ opacity: opacity( key ) }" alt="" />

  </div>

</template>
